/* Global quick add: any [data-bk-quick-add] button adds its variant via /cart/add.js and opens Dawn's cart drawer. */
(function () {
  if (window.bkQuickAddLoaded) return;
  window.bkQuickAddLoaded = true;

  const DEFAULT_ERROR = 'Could not add to cart. Please try again.';

  function showError(button, message) {
    const holder = button.closest('.bk-card__action') || button.parentElement;
    let box = holder && holder.querySelector('.bk-card__error, [data-bk-quick-add-error]');
    if (!box && holder) {
      box = document.createElement('p');
      box.className = 'bk-card__error';
      box.setAttribute('role', 'alert');
      holder.appendChild(box);
    }
    if (box) {
      box.textContent = message;
      box.hidden = false;
    }
  }

  function clearError(button) {
    const holder = button.closest('.bk-card__action') || button.parentElement;
    const box = holder && holder.querySelector('.bk-card__error, [data-bk-quick-add-error]');
    if (box) {
      box.textContent = '';
      box.hidden = true;
    }
  }

  async function quickAdd(button) {
    const variantId = Number(button.dataset.variantId);
    if (!variantId || button.classList.contains('is-loading')) return;

    const cartDrawer = document.querySelector('cart-drawer');
    const sections = cartDrawer ? cartDrawer.getSectionsToRender().map((section) => section.id) : [];

    clearError(button);
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');

    try {
      const body = { id: variantId, quantity: 1 };
      if (sections.length) {
        body.sections = sections.join(',');
        body.sections_url = window.location.pathname;
      }

      const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || DEFAULT_ERROR);
      }

      document.dispatchEvent(new CustomEvent('bk:cart-added', { detail: { variantId, result } }));

      if (cartDrawer) {
        // Dawn's renderContents swaps the drawer + cart-icon-bubble sections and opens the drawer.
        cartDrawer.renderContents(result);
      } else {
        window.location.href = window.routes?.cart_url || '/cart';
      }
    } catch (error) {
      showError(button, (error && error.message) || window.cartStrings?.error || DEFAULT_ERROR);
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-bk-quick-add]');
    if (!button) return;
    event.preventDefault();
    quickAdd(button);
  });
})();
